module.exports = __webpack_public_path__ + "media/packs/images/flags/NI-c91e3867f4e1222569dff46934ed6b47.png";